import { render } from "./InsuranceForm.vue?vue&type=template&id=08e389fc&scoped=true"
import script from "./InsuranceForm.vue?vue&type=script&lang=js"
export * from "./InsuranceForm.vue?vue&type=script&lang=js"

import "./InsuranceForm.vue?vue&type=style&index=0&id=08e389fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e389fc"]])

export default __exports__